// extracted by mini-css-extract-plugin
export default {"printOptionTag":"Table_printOptionTag__RAFFS"};